import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserPredictionsListState, UserPredictionsListStateModel } from './user-predictions-list.state';
import { SetInitialStateFacade } from '../../../../../common/models';
import { UserPredictionsListInitialState, UserPredictionsListLoad } from './user-predictions-list.actions';
import { UserPredictionModel } from '../models/user-prediction.model';

@Injectable({ providedIn: 'root' })
export class UserPredictionsListFacade implements SetInitialStateFacade {
  listDto$: Observable<UserPredictionsListStateModel> = this.store.select(UserPredictionsListState.getState);
  items$: Observable<UserPredictionModel[]> = this.store.select(UserPredictionsListState.getItems);

  constructor(private store: Store) {}

  loadAll(filter: string): void {
    this.store.dispatch(new UserPredictionsListLoad({ filter }));
  }

  setInitialState(): void {
    this.store.dispatch(new UserPredictionsListInitialState());
  }
}
